var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.816528 1.85718C0.816528 1.22827 1.30872 0.70874 1.93762 0.70874H13.6681C14.297 0.70874 14.8165 1.22827 14.8165 1.85718C14.8165 2.13062 14.7072 2.37671 14.5431 2.56812L10.004 8.17358V12.0837C10.004 12.5759 9.59387 12.9587 9.10168 12.9587C8.91028 12.9587 8.71887 12.9041 8.55481 12.7673L6.03918 10.7712C5.76575 10.5525 5.62903 10.2517 5.62903 9.92358V8.17358L1.06262 2.56812C0.89856 2.37671 0.816528 2.13062 0.816528 1.85718ZM2.29309 2.02124L6.77747 7.51733C6.88684 7.65405 6.94153 7.79077 6.94153 7.92749V9.81421L8.69153 11.2087V7.92749C8.69153 7.79077 8.71887 7.65405 8.82825 7.51733L13.3126 2.02124H2.29309Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.b3009fe88f84f1cefcc62b7220df809e.svg";
export { ForwardRef as ReactComponent };